import { updateInpCurrentEvent } from '@/common/perf/inp';
import React from 'react';
import {
    TouchableWithoutFeedbackProps,
    TouchableOpacityProps,
    GestureResponderEvent,
    // eslint-disable-next-line no-restricted-imports
    TouchableWithoutFeedback,
    // eslint-disable-next-line no-restricted-imports
    TouchableOpacity,
} from 'react-native';
import {
    TouchableWithoutFeedback as TouchableGestureWithoutFeedback,
    TouchableOpacity as TouchableGestureOpacity,
} from 'react-native-gesture-handler';

export const KTouchableWithoutFeedback: React.FC<TouchableWithoutFeedbackProps> = props => {
    if (!props.onPress) {
        return <TouchableWithoutFeedback {...props}>{props.children}</TouchableWithoutFeedback>;
    }

    // 绑定前置的 onPress
    const onPress = (e: GestureResponderEvent) => {
        // updateInpCurrentEvent(e);
        props.onPress(e);
    };

    return (
        <TouchableWithoutFeedback {...props} onPress={onPress}>
            {props.children}
        </TouchableWithoutFeedback>
    );
};

export const KTouchableOpacity: React.FC<TouchableOpacityProps> = props => {
    if (!props.onPress) {
        return <TouchableOpacity {...props}>{props.children}</TouchableOpacity>;
    }

    const onPress = (e: GestureResponderEvent) => {
        // updateInpCurrentEvent(e);
        props.onPress(e);
    };
    return (
        <TouchableOpacity {...props} onPress={onPress}>
            {props.children}
        </TouchableOpacity>
    );
};

export const KTouchableGestureWithoutFeedback: React.FC<TouchableWithoutFeedbackProps> = props => {
    if (!props.onPress) {
        return <TouchableGestureWithoutFeedback {...props}>{props.children}</TouchableGestureWithoutFeedback>;
    }

    const onPress = (e: GestureResponderEvent) => {
        // updateInpCurrentEvent(e);
        props.onPress(e);
    };

    return (
        <TouchableGestureWithoutFeedback {...props} onPress={onPress}>
            {props.children}
        </TouchableGestureWithoutFeedback>
    );
};

export const KTouchableGestureOpacity: React.FC<TouchableOpacityProps> = props => {
    if (!props.onPress) {
        return <TouchableGestureOpacity {...props}>{props.children}</TouchableGestureOpacity>;
    }

    const onPress = (e: GestureResponderEvent) => {
        // updateInpCurrentEvent(e);
        props.onPress(e);
    };
    return (
        <TouchableGestureOpacity {...props} onPress={onPress}>
            {props.children}
        </TouchableGestureOpacity>
    );
};
